export default (state = false, action) => {
  switch (action.type) {
    case 'FETCH_PUZZLE_INFO':
      return { ...state, ...action.payload } || false
    default:
      return state
  }
}